import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { Observable } from "rxjs";
import {
  RequestCreateLocationDto,
  RequestFindDetailLocationDto, ResponseCreateLocationDto,
  ResponsetFindDetailLocationDto
} from "../dto/ttademp-location.dto";

@Injectable()
export class TtadempLocationApi {
  private service: string = '';
  private model: string = 'ttademplocation';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public findDetailLocation(data: RequestFindDetailLocationDto): Observable<ResponsetFindDetailLocationDto> {
    const method: string = 'POST';
    const func: string = 'findDetailLocation';
    const params: RequestFindDetailLocationDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsetFindDetailLocationDto>(method, url, params, urlParams, body);
  }

  public createLocation(data: RequestCreateLocationDto): Observable<ResponseCreateLocationDto> {
    const method: string = 'POST';
    const func: string = 'createLocation';
    const params: RequestCreateLocationDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseCreateLocationDto>(method, url, params, urlParams, body);
  }




}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/ttademp-location.api.ts